export default __webpack_public_path__ + "static/media/icon-qa-dark.72df1e2a.svg";